// forked from https://github.com/GetStream/stream-chat-react/blob/master/src/components/ChannelHeader/ChannelHeader.tsx

import { ArrowBack, PeopleAltOutlined } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { useChannelStateContext, useChatContext } from 'stream-chat-react'
import ConversationActionsMenu from './components/conversation-actions'
import MembersModal from './components/members-modal'

const ChannelHeader = () => {
  const { channel } = useChannelStateContext()
  const { client, openMobileNav } = useChatContext()
  const [otherMembers, setOtherMembers] = useState([])
  const maxMembers = 300 // this is current stream-chat fetch limit per request
  const currentUserId = client.user?.id
  const memberCount = channel?.state?.members
    ? Object.values(channel.state.members).length
    : 0

  useEffect(() => {
    let isMounted = true
    const fetchAllMembers = async () => {
      let offset = 0
      let allMembers = []
      while (true) {
        const result = await channel.query({
          state: true,
          members: { limit: maxMembers, offset },
        })
        const batch = result.members || []
        allMembers = allMembers.concat(batch)
        if (batch.length < maxMembers) break
        offset += maxMembers
      }
      if (isMounted) {
        allMembers = allMembers
          .filter(m => m.user_id !== currentUserId)
          .map(m => m.user)
        setOtherMembers(allMembers)
      }
    }
    fetchAllMembers()
    return () => {
      isMounted = false
    }
  }, [channel, currentUserId, memberCount])

  const { name, description } = channel?.data || {}

  const title = (() => {
    if (name) return name
    if (otherMembers.length > 3) {
      return `${otherMembers
        .slice(0, 3)
        .map(u => u.name)
        .join(', ')}, and ${otherMembers.length - 3} other(s)`
    }
    return otherMembers.map(u => u.name).join(', ')
  })()

  return (
    <div className="str-chat__header-livestream">
      <div className="str-chat__header-hamburger" onClick={openMobileNav}>
        <ArrowBack />
      </div>
      <div className="str-chat__header-livestream-left">
        <p className="str-chat__header-livestream-left--title">{title} </p>
        {description && (
          <p className="str-chat__header-livestream-left--subtitle">
            {description}
          </p>
        )}
        <p className="str-chat__header-livestream-left--members">
          {!!otherMembers && otherMembers.length > 1 && (
            <>{`${otherMembers.length + 1} members`}</>
          )}
        </p>
      </div>
      <div className="str-chat__header-livestream-right">
        <MembersModal
          currentUserId={currentUserId}
          channel={channel}
          trigger={
            <PeopleAltOutlined
              style={{ marginRight: '8px', cursor: 'pointer' }}
            />
          }
        />
      </div>
      <div className="str-chat__header-livestream-right">
        <ConversationActionsMenu channel={channel} />
      </div>
    </div>
  )
}

export default ChannelHeader
